import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon } from 'lucide-react';
import { mockData } from '../utils/mockData';
export const EvidenceTable = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const filteredData = mockData.sidebar.bodycamFootage.filter(item => item.title.toLowerCase().includes(search.toLowerCase()) || item.id.toLowerCase().includes(search.toLowerCase()));
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const currentData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  return <main className="flex-grow p-12 overflow-auto bg-[#0a1120]" data-id="element-212">
      <div className="max-w-[1000px] mx-auto" data-id="element-213">
        <h1 className="text-3xl font-bold text-white mb-8 tracking-tight" data-id="element-214">
          Evidence Search
        </h1>
        <div className="mb-8 relative" data-id="element-215">
          <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-[#666666]" size={20} data-id="element-216" />
          <input type="text" placeholder="Search evidence..." value={search} onChange={e => {
          setSearch(e.target.value);
          setCurrentPage(1);
        }} className="w-full pl-12 pr-4 py-3 bg-[#151A22]/50 border border-white/5 rounded-xl text-[#e0e0e0] placeholder:text-[#444444] focus:outline-none focus:border-white/10 transition-colors text-lg" data-id="element-217" />
        </div>
        <div className="border border-white/5 rounded-2xl overflow-hidden bg-[#151A22]/40" data-id="element-218">
          <table className="w-full" data-id="element-219">
            <thead className="bg-white/5" data-id="element-220">
              <tr data-id="element-221">
                <th className="px-6 py-4 text-left text-xs font-bold uppercase tracking-widest text-[#888888]" data-id="element-222">
                  Title
                </th>
                <th className="px-6 py-4 text-left text-xs font-bold uppercase tracking-widest text-[#888888]" data-id="element-223">
                  ID
                </th>
                <th className="px-6 py-4 text-left text-xs font-bold uppercase tracking-widest text-[#888888]" data-id="element-224">
                  Date
                </th>
              </tr>
            </thead>
            <tbody data-id="element-225">
              {currentData.map(item => <tr key={item.id} className="border-t border-white/5 hover:bg-white/5 transition-colors" data-id="element-226">
                  <td className="px-6 py-4" data-id="element-227">
                    <button onClick={() => navigate(`/transcript/${item.id}`)} className="text-[#4a90e2] font-medium hover:underline text-left" data-id="element-228">
                      {item.title}
                    </button>
                  </td>
                  <td className="px-6 py-4 text-sm text-[#e0e0e0]" data-id="element-229">
                    {item.id}
                  </td>
                  <td className="px-6 py-4 text-sm text-[#e0e0e0]" data-id="element-230">
                    {item.date}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="mt-4 flex items-center justify-between" data-id="element-231">
          <div className="text-sm text-[#888888]" data-id="element-232">
            Showing {(currentPage - 1) * itemsPerPage + 1} to{' '}
            {Math.min(currentPage * itemsPerPage, filteredData.length)} of{' '}
            {filteredData.length} results
          </div>
          <div className="flex gap-2" data-id="element-233">
            {Array.from({
            length: totalPages
          }, (_, i) => <button key={i} onClick={() => setCurrentPage(i + 1)} className={`px-3 py-1 rounded-md text-sm font-medium transition-all ${currentPage === i + 1 ? 'bg-[#4a90e2] text-white shadow-lg shadow-[#4a90e2]/20' : 'bg-white/5 text-[#888888] hover:bg-white/10 hover:text-[#e0e0e0]'}`} data-id="element-234">
                  {i + 1}
                </button>)}
          </div>
        </div>
      </div>
    </main>;
};